module.exports = __webpack_public_path__ + "static/media/wenti2.953f1ae8.png";